import { prioritiseMedia, getMinWidth } from './mediaUtils'

const getImage = (data) => {

  const nodeArray = [ ...data.querySelectorAll('communication link') ]
    .filter(node => node.getAttribute('title') === 'preview')

  return (nodeArray.length) ? nodeArray[ 0 ].getAttribute('href') : ''

}

const getMedia = (data) => {

  const rawNodes = [ ...data.querySelectorAll('recordedState source') ].map(node => {

    return {
      src: node.getAttribute('src') || '',
      minWidth: getMinWidth(node)
    }

  })

  return prioritiseMedia(rawNodes)

}

const xmlCommunicationHandler = (data) => {

  const parser = new DOMParser()
  const doc = parser.parseFromString(data, 'application/xml')

  return {
    image: getImage(doc),
    media: getMedia(doc)
  }

}

export default xmlCommunicationHandler
